/* eslint-disable */

import logo from "./logo.svg";
import "./App.css";
import {Routes, Route, Outlet, Link, Navigate, useParams, useLocation} from "react-router-dom";
import React, { useState, useEffect } from "react";
import AuthProvider from "./providers/AuthProvider";
import {useAuth} from "./providers/AuthProvider";
import LoginPage from "./LoginPage";
import ForgotPasswordPage from "./ForgotPasswordPage";
import ResetPasswordPage from "./ResetPasswordPage";
import {Registration} from "./Registration"
import {EnrolledCourses} from "./EnrolledCourses";
import {EachCourse} from "./EachCourse";
import {Profile} from "./Profile";
import SignaturePad from 'react-signature-canvas'
import { useNavigate } from "react-router-dom"; 
import { ChevronDownIcon } from "@chakra-ui/icons";
import {
    Avatar,
    Box,
    Button,
    ButtonGroup,
    Container,
    HStack,
    Icon,
    IconButton,
    Input,
    InputGroup,
    InputLeftElement,
    MenuButton,
    MenuDivider,
    MenuGroup,
    MenuList,
    MenuItem,
    Menu,
} from "@chakra-ui/react";
import { FiBell, FiSearch } from "react-icons/fi";
import {
    Center,
    FormControl,
    Heading,
    Image,
    Select,
    Stack,
    VStack,
    Text,
    FormLabel,
    Spinner, Badge, Alert, AlertIcon,
    useToast
} from "@chakra-ui/react";
import {supabase} from "./utils/supabaseClient";
import {CheckCircleIcon} from "@chakra-ui/icons";
import {Attendance} from "./Attendance";
import {AssessmentForCourses} from "./AssessmentForCourses";
import {EachAssessment} from "./EachAssessment";
import TestLMS from "./TestPage";
import QRTesting from "./QRTesting";
import {Enrollment} from "./Enrollment";
import {SuccessPage} from "./SuccessPage";
import {SuccessRegistration} from "./SuccessRegistration";
import {SuccessAcknowledgement} from "./SuccessAcknowledgement";
import { AttendanceSelection } from "./AttendanceSelection";
import { SMECheck } from "./SME_check";
import { CourseInterestReceived } from "./CourseInterestReceived";
import { CourseRegistrationForm } from "./CourseRegistrationForm";
import { CertificateSelection } from "./CertificateSelection";
import Forms from "./Forms";
import { motion } from "framer-motion";
import { HiPaperAirplane, HiLightBulb, HiBookOpen } from "react-icons/hi";
import { COLORS } from "./styles/colors";
import SSGAPI from "./SSGAPI";
import CreditPayAPI from "./CreditPayAPI";
import FullCertRegistration from "./FullCertRegistration";
import RegistrationPending from "./RegistrationPending";
import { useRouteConfig } from "./providers/RouteConfigProvider";
import { StudentPackage } from "./StudentPackage";
import VerifyEmail from "./VerifyEmail";
import { getPhotoUrlFromAdditionalData } from "./utils/profilePhoto";

const Home = () => {
    return (
        <Heading>Test</Heading>
    )
}

const Courses = () => {
    return (
        "Courses"
    )
}

const ProtectedRoute = ({
                            redirectPath = '/login',
                            children,
                        }) => {
    const {auth, isLoading} = useAuth()
    //console.log(auth)
    if (auth && !isLoading) {
        return children;
    } else if (!isLoading) {
        return <Navigate to={redirectPath} replace/>;
    }

};


const Acknowledgement = () => {
    const [registration, setRegistration] = useState(null)
    const [submitting, setSubmitting] = useState(false)
    const { registrationId } = useParams();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const payment_stage = params.get("session_id")
    const getRegistration = async () => {
        const { data, error } = await supabase
            .from("registration")
            .select("participant_name, id, participant_email, registration_stage, course_run_details!inner(*)")
            .eq("id", registrationId)
            .single()

        if (data) {
            //console.log(data);
            setRegistration(data);
        }
        if (error) {
            console.log(error);
        }
    };

    const handleCheckout = async () => {
        setSubmitting(true)
        try {
            const response = await fetch('https://eovhmnu1acpextc.m.pipedream.net', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    product_id: registration.course_run_details.course_type_code,
                    registration_id: registrationId,
                    participant_email: registration.participant_email
                }),
            });

            const data = await response.json();

            if (data.url) {
                window.location.href = data.url;
                setSubmitting(false);
            } else {
                console.error('No URL found in response');
            }
        } catch (error) {
            console.error('Error during the checkout process:', error);
        }
    };

    useEffect(() => {
        getRegistration()
    }, [])

    return (
        registration === null
            ?
            <Spinner/>
            :
            <Box w={"100%"} display="flex" justifyContent="center" alignItems="center" bg={"#F4EEEA"} m={"auto"}>
            <Center maxW={"90%"} width={800} pt={10} pb={20}>

                <Stack spacing="4" width="100%">
                    <Heading size={"sm"} mb={2}>{registration.registration_stage === "confirmed" || payment_stage !== "failed" ? "Course Confirmation" : "Registration Details - Pending Payment"}</Heading>
                    <Alert status='warning' mb={5}>
                        <AlertIcon />
                        {registration.registration_stage === "confirmed" || payment_stage !== "failed" ? `You will receive a course confirmation email sent to ${registration.participant_email} shortly. Please reach out to courses@sozcode.com if you did not receive the email.` : "This is not a confirmation of your registration. Please click on the checkout button below to complete your checkout."}
                    </Alert>
                    {
                        registration.registration_stage === "confirmed" || payment_stage !== "failed"
                            ? null
                            : <Button onClick={handleCheckout} isLoading={submitting}>Proceed to checkout</Button>
                    }

                    <HStack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            Registration Stage
                        </Text>
                        <Box>
                            <Badge colorScheme={registration.registration_stage === "confirmed" || payment_stage !== "failed" ? 'green' : 'red'}>{registration.registration_stage === "confirmed" || payment_stage !== "failed" ? "Payment Received" : "Pending Payment"}</Badge>
                        </Box>
                    </HStack>
                    <HStack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            Participant Name
                        </Text>
                        <Text fontWeight={600}>{registration.participant_name}</Text>
                    </HStack>
                    <HStack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            Course Title
                        </Text>
                        <Text fontWeight={600}>{registration.course_run_details.name}</Text>
                    </HStack>
                    <HStack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            Course Start Date
                        </Text>
                        <Text fontWeight={600}>{registration.course_run_details.start_date}</Text>
                    </HStack>
                    <HStack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            Course End Date
                        </Text>
                        <Text fontWeight={600}>{registration.course_run_details.end_date}</Text>
                    </HStack>
                    <Stack mb={1}>
                        <Text w={200} color="fg.muted" fontWeight={400}>
                            <u>Venue</u>
                        </Text>
                        <Text fontWeight={400}>{registration.course_run_details.venue}<br/><br/>{registration.course_run_details.attachment}</Text>
                    </Stack>
                    <Text w={200} color="fg.muted" fontWeight={400}>
                        <u>Pre-course brief</u>
                    </Text>
                    <Text fontWeight={400}>
                        {registration.course_run_details.admin_brief}
                    </Text>
                </Stack>
            </Center>
        </Box>
    )
}

const protected_routes = [
    {
        path: '/home',
        element:
            <ProtectedRoute>
                <Home/>
            </ProtectedRoute>
    },
    {
        path: '/my-courses',
        element:
            <ProtectedRoute>
                <Courses/>
            </ProtectedRoute>
    },
    {
        path: '/enrolled-courses',
        element:
            <ProtectedRoute>
                <EnrolledCourses/>
            </ProtectedRoute>
    },
    {
        path: '/all-assessments',
        element:
            <ProtectedRoute>
                <AssessmentForCourses/>
            </ProtectedRoute>
    },
    {
        path: '/assessment/:assessmentID',
        element:
            <ProtectedRoute>
                <EachAssessment/>
            </ProtectedRoute>
    }
]

const LandingPage = () => {
    const navigate = useNavigate();
    
    return (
        <Box 
            minH="100vh" 
            bg="gray.50"
            display="flex" 
            alignItems="center" 
            justifyContent="center"
            p={{ base: 2, md: 4 }}
        >
            <motion.div
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6 }}
                style={{ width: '100%', maxWidth: '1200px' }}
            >
                <Box 
                    bg="white" 
                    p={{ base: 4, md: 8, lg: 12 }} 
                    borderRadius={{ base: "lg", md: "xl" }} 
                    boxShadow="2xl" 
                    textAlign="center"
                    border="1px solid"
                    borderColor="gray.200"
                >
                    {/* Header Section */}
                    <motion.div
                        initial={{ scale: 0.9 }}
                        animate={{ scale: 1 }}
                        transition={{ delay: 0.2, duration: 0.5 }}
                    >
                        <Box mb={{ base: 6, md: 8 }}>
                            <Text 
                                fontSize={{ base: "3xl", md: "4xl", lg: "5xl" }} 
                                mb={{ base: 4, md: 6 }}
                                color="gray.600"
                            >
                                🎓
                            </Text>
                            
                            <Heading 
                                size={{ base: "sm", md: "md" }} 
                                mb={{ base: 3, md: 4 }} 
                                color="gray.800"
                                fontWeight="700"
                            >
                                Welcome
                            </Heading>
                            
                            <Text 
                                mb={{ base: 6, md: 8 }} 
                                color="gray.600"
                                fontSize={{ base: "md", md: "lg", lg: "xl" }}
                                maxW="600px"
                                mx="auto"
                                lineHeight="1.6"
                                px={{ base: 2, md: 0 }}
                            >
                                Empowering learners with comprehensive courses, professional certifications, and flexible learning paths designed for your success.
                            </Text>
                        </Box>
                    </motion.div>

                    {/* Features Grid */}
                    <motion.div
                        initial={{ opacity: 0, y: 30 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.4, duration: 0.6 }}
                    >
                        <Box 
                            display="grid" 
                            gridTemplateColumns={{ base: "1fr", md: "repeat(3, 1fr)" }}
                            gap={{ base: 4, md: 6 }} 
                            mb={{ base: 6, md: 10 }}
                        >
                            <Box p={{ base: 4, md: 6 }} bg="gray.50" borderRadius="lg" border="1px solid" borderColor="gray.200">
                                <Text fontSize={{ base: "2xl", md: "3xl" }} mb={{ base: 2, md: 3 }}>📚</Text>
                                <Heading size={{ base: "xs", md: "sm" }} mb={2} color="gray.800">Comprehensive Courses</Heading>
                                <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }}>
                                    Access a wide range of professional courses designed by industry experts
                                </Text>
                            </Box>
                            
                            <Box p={{ base: 4, md: 6 }} bg="gray.50" borderRadius="lg" border="1px solid" borderColor="gray.200">
                                <Text fontSize={{ base: "2xl", md: "3xl" }} mb={{ base: 2, md: 3 }}>🏆</Text>
                                <Heading size={{ base: "xs", md: "sm" }} mb={2} color="gray.800">Professional Certifications</Heading>
                                <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }}>
                                    Earn recognised certifications that advance your career and skills
                                </Text>
                            </Box>
                            
                            <Box p={{ base: 4, md: 6 }} bg="gray.50" borderRadius="lg" border="1px solid" borderColor="gray.200">
                                <Text fontSize={{ base: "2xl", md: "3xl" }} mb={{ base: 2, md: 3 }}>⚡</Text>
                                <Heading size={{ base: "xs", md: "sm" }} mb={2} color="gray.800">Flexible Learning</Heading>
                                <Text color="gray.600" fontSize={{ base: "xs", md: "sm" }}>
                                    Learn at your own pace with flexible schedules and online access
                                </Text>
                            </Box>
                        </Box>
                    </motion.div>

                    {/* Action Buttons */}
                    <motion.div
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: 0.6, duration: 0.5 }}
                    >
                        <VStack spacing={{ base: 3, md: 4 }}>
                            <Text 
                                color="gray.700" 
                                fontSize={{ base: "md", md: "lg" }} 
                                fontWeight="600" 
                                mb={2}
                            >
                                Ready to get started?
                            </Text>
                            
                            <VStack 
                                spacing={{ base: 3, md: 4 }}
                                w="100%"
                                align="stretch"
                                display={{ base: "flex", md: "none" }}
                            >
                                <Button
                                    onClick={() => navigate('/courses-and-programs')}
                                    size={{ base: "md", md: "lg" }}
                                    bg="gray.800"
                                    color="white"
                                    _hover={{ bg: 'gray.700', transform: 'translateY(-2px)' }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiBookOpen} transform="rotate(-45deg)" />}
                                    px={{ base: 4, md: 8 }}
                                    py={{ base: 4, md: 6 }}
                                    fontSize={{ base: "sm", md: "md" }}
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="lg"
                                    transition="all 0.2s"
                                    w="100%"
                                >
                                    View All Courses and Programs
                                </Button>
                                
                                <Button
                                    onClick={() => navigate('/login')}
                                    size={{ base: "md", md: "lg" }}
                                    variant="outline"
                                    borderColor="gray.300"
                                    color="gray.700"
                                    _hover={{ 
                                        bg: 'gray.100', 
                                        borderColor: 'gray.400',
                                        transform: 'translateY(-2px)'
                                    }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiLightBulb} />}
                                    px={{ base: 4, md: 8 }}
                                    py={{ base: 4, md: 6 }}
                                    fontSize={{ base: "sm", md: "md" }}
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="md"
                                    transition="all 0.2s"
                                    w="100%"
                                >
                                    I'm a Student
                                </Button>

                                <Button
                                    onClick={() => navigate('/forms')}
                                    size={{ base: "md", md: "lg" }}
                                    variant="outline"
                                    borderColor="gray.300"
                                    color="gray.700"
                                    _hover={{ 
                                        bg: 'gray.100', 
                                        borderColor: 'gray.400',
                                        transform: 'translateY(-2px)'
                                    }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiLightBulb} />}
                                    px={{ base: 4, md: 8 }}
                                    py={{ base: 4, md: 6 }}
                                    fontSize={{ base: "sm", md: "md" }}
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="md"
                                    transition="all 0.2s"
                                    w="100%"
                                >
                                    Forms
                                </Button>
                            </VStack>

                            <HStack 
                                spacing={6} 
                                justify="center" 
                                flexWrap="wrap"
                                gap={4}
                                display={{ base: "none", md: "flex" }}
                            >
                                <Button
                                    onClick={() => navigate('/courses-and-programs')}
                                    size="lg"
                                    bg="gray.800"
                                    color="white"
                                    _hover={{ bg: 'gray.700', transform: 'translateY(-2px)' }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiBookOpen} transform="rotate(-45deg)" />}
                                    px={8}
                                    py={6}
                                    fontSize="md"
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="lg"
                                    transition="all 0.2s"
                                >
                                    View All Courses and Programs
                                </Button>
                                
                                <Button
                                    onClick={() => navigate('/login')}
                                    size="lg"
                                    variant="outline"
                                    borderColor="gray.300"
                                    color="gray.700"
                                    _hover={{ 
                                        bg: 'gray.100', 
                                        borderColor: 'gray.400',
                                        transform: 'translateY(-2px)'
                                    }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiLightBulb} />}
                                    px={8}
                                    py={6}
                                    fontSize="md"
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="md"
                                    transition="all 0.2s"
                                >
                                    I'm a Student
                                </Button>

                                <Button
                                    onClick={() => navigate('/forms')}
                                    size="lg"
                                    variant="outline"
                                    borderColor="gray.300"
                                    color="gray.700"
                                    _hover={{ 
                                        bg: 'gray.100', 
                                        borderColor: 'gray.400',
                                        transform: 'translateY(-2px)'
                                    }}
                                    _active={{ transform: 'translateY(0)' }}
                                    leftIcon={<Icon as={HiLightBulb} />}
                                    px={8}
                                    py={6}
                                    fontSize="md"
                                    fontWeight="600"
                                    borderRadius="lg"
                                    boxShadow="md"
                                    transition="all 0.2s"
                                >
                                    Forms
                                </Button>
                            </HStack>
                        </VStack>
                    </motion.div>

                    {/* Footer */}
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        transition={{ delay: 0.8, duration: 0.5 }}
                    >
                        <Box mt={{ base: 6, md: 12 }} pt={{ base: 4, md: 6 }} borderTop="1px solid" borderColor="gray.200">
                            <Text color="gray.500" fontSize={{ base: "xs", md: "sm" }}>
                                Powered by Edthos
                            </Text>
                        </Box>
                    </motion.div>
                </Box>
            </motion.div>
        </Box>
    );
};

function App() {
    const {user,isLoading} = useAuth();
    const {signOut} = useAuth();
    const { routes } = useRouteConfig();
    const navigate = useNavigate();
    const location = useLocation();
    //console.log("User in App.js:", { user, isLoading });
    const [orgBranding, setOrgBranding] = useState({ logoUrl: null, name: "" });

    useEffect(() => {
        let cancelled = false;

        const loadOrgBranding = async () => {
            try {
                const { data, error } = await supabase
                    .from("organization")
                    .select("logo_url, name")
                    .eq("status", "active")
                    .limit(1)
                    .maybeSingle();

                if (error) throw error;
                if (!cancelled && data) {
                    setOrgBranding({
                        logoUrl: data.logo_url || null,
                        name: data.name || "",
                    });
                }
            } catch (error) {
                console.error("Error loading organization branding:", error);
            }
        };

        loadOrgBranding();
        return () => {
            cancelled = true;
        };
    }, []);
    
    const isUnprotectedPage = ["/registration", routes.FULL_CERT_REGISTRATION, "/courses-and-programs", "/attendance", "/confirmation", "/enrollment", "/student-package", "/success", "/testpage", "/qr-testing", "/login", "/forgot-password", "/reset-password", "/course-interest-received", "/forms", "/course-registration-form"].some((path) =>
        location.pathname.startsWith(path)
    );

    const isAuthStandalonePage = ["/login", "/forgot-password", "/reset-password"].includes(
        location.pathname
    );

    const [participantName, setParticipantName] = useState("");
    const [profilePhotoUrl, setProfilePhotoUrl] = useState(null);
    useEffect(() => {
        const fetchParticipantProfile = async () => {
            if (!user || isUnprotectedPage) {
                setProfilePhotoUrl(null);
                return;
            }

            // Prefer latest registration; try user_id first, then email
            let name = "";
            let photoUrl = null;
            const { data: byUserId, error: userIdError } = await supabase
                .from("registration")
                .select("participant_name, additional_data, created_at")
                .eq("user_id", user.id)
                .order("created_at", { ascending: false })
                .limit(1);

            if (userIdError) {
                console.error("Error fetching participant profile by user_id:", userIdError);
            } else if (byUserId?.[0]) {
                name = byUserId[0].participant_name || "";
                photoUrl = getPhotoUrlFromAdditionalData(byUserId[0].additional_data);
            }

            if ((!name || !photoUrl) && user.email) {
                const { data: byEmail, error: emailError } = await supabase
                    .from("registration")
                    .select("participant_name, additional_data, created_at")
                    .ilike("participant_email", user.email)
                    .order("created_at", { ascending: false })
                    .limit(1);

                if (emailError) {
                    console.error("Error fetching participant profile by email:", emailError);
                } else if (byEmail?.[0]) {
                    if (!name) name = byEmail[0].participant_name || "";
                    if (!photoUrl) {
                        photoUrl = getPhotoUrlFromAdditionalData(byEmail[0].additional_data);
                    }
                }
            }

            // Fallback: auth metadata full name if registration has none
            if (!name) {
                name = user?.user_metadata?.full_name || user?.user_metadata?.name || "";
            }

            setParticipantName(name);
            setProfilePhotoUrl(photoUrl);
        };
        fetchParticipantProfile();
    }, [user, isUnprotectedPage]);

    useEffect(() => {
        //console.log("Checking if Intercom should load...");
    
        if (!isUnprotectedPage||location.pathname.startsWith("/registration") || location.pathname.startsWith("/enrollment")) {
            //console.log("Loading Intercom...");
    
            window.intercomSettings = {
                api_base: "https://api-iam.intercom.io",
                app_id: "lol6oaa6",
            };
    
            (function () {
                var w = window;
                var ic = w.Intercom;
                if (typeof ic === "function") {
                    //console.log("Intercom function found, updating...");
                    ic("reattach_activator");
                    ic("update", w.intercomSettings);
                } else {
                    //console.log("Intercom function not found, injecting script...");
                    var d = document;
                    var i = function () {
                        i.c(arguments);
                    };
                    i.q = [];
                    i.c = function (args) {
                        i.q.push(args);
                    };
                    w.Intercom = i;
                    var l = function () {
                        var s = d.createElement("script");
                        s.type = "text/javascript";
                        s.async = true;
                        s.src = "https://widget.intercom.io/widget/lol6oaa6";
                        var x = d.getElementsByTagName("script")[0];
                        x.parentNode.insertBefore(s, x);
                    };
                    if (document.readyState === "complete") {
                        l();
                    } else if (w.attachEvent) {
                        w.attachEvent("onload", l);
                    } else {
                        w.addEventListener("load", l, false);
                    }
                }
            })();
        } else {
            //console.log("Intercom should NOT load on this page.");
            if (window.Intercom) {
                //console.log("Shutting down Intercom...");
                window.Intercom("shutdown");
            }
        }
    }, [location.pathname]); // Runs on route change

    const handleLogout = async () => {
        try {
            await signOut(); // Call signOut from the context
            navigate("/login");
          } catch (error) {
            console.error("Error logging out:", error);
          }
        };

    console.log(isUnprotectedPage);

    const emailLocalPart = user?.email ? user.email.split("@")[0] : "Guest";
    // Header button: short label. Dropdown: full registration name when available.
    const headerShortName = emailLocalPart;
    const dropdownFullName = participantName || emailLocalPart;

    return (
            <AuthProvider>
                <Box>
                    {!isAuthStandalonePage && (
                    <Box as="header">
                        <Box
                            borderBottomWidth="1px"
                            borderColor="gray.200"
                            position="relative"
                            zIndex="tooltip"
                            bg="white"
                        >
                            <Container py={{ base: 3, md: 3.5 }} maxW="container.xl">
                                <HStack justify="space-between" align="center" spacing={4}>
                                    <Link to="/enrolled-courses" aria-label="Go to enrolled courses">
                                        {orgBranding.logoUrl ? (
                                            <Image
                                                w={{ base: "160px", md: "200px" }}
                                                src={orgBranding.logoUrl}
                                                alt={orgBranding.name || "Organization logo"}
                                                cursor="pointer"
                                            />
                                        ) : (
                                            <Text
                                                fontSize={{ base: "md", md: "lg" }}
                                                fontWeight="700"
                                                color="gray.800"
                                                cursor="pointer"
                                            >
                                                {orgBranding.name || "Home"}
                                            </Text>
                                        )}
                                    </Link>

                                    {!isUnprotectedPage && (
                                    <HStack spacing="3">
                                        {user ? (
                                            <Menu>
                                            <MenuButton
                                                as={Box}
                                                cursor="pointer"
                                                display="inline-flex"
                                                alignItems="center"
                                                px={2}
                                                py={1.5}
                                                borderRadius="full"
                                                transition="background 0.15s ease"
                                                _hover={{ bg: "gray.100" }}
                                                _active={{ bg: "gray.200" }}
                                                _expanded={{ bg: "gray.100" }}
                                                _focus={{ outline: "none", boxShadow: "none" }}
                                                _focusVisible={{ outline: "none", bg: "gray.100" }}
                                            >
                                                <HStack spacing={2} maxW={{ base: "140px", sm: "200px", md: "240px" }}>
                                                    <Avatar
                                                        size="sm"
                                                        name={dropdownFullName}
                                                        src={profilePhotoUrl || user?.user_metadata?.avatar_url}
                                                        bg="teal.500"
                                                        color="white"
                                                        flexShrink={0}
                                                    />
                                                    <Text
                                                      fontSize="sm"
                                                      fontWeight="medium"
                                                      noOfLines={1}
                                                      display={{ base: "none", sm: "block" }}
                                                    >
                                                        {headerShortName}
                                                    </Text>
                                                    <ChevronDownIcon flexShrink={0} />
                                                </HStack>
                                            </MenuButton>
                                            <MenuList minW="240px">
                                                <Box px={3} py={2}>
                                                    <Text fontSize="sm" fontWeight="semibold" noOfLines={1}>
                                                        {dropdownFullName}
                                                    </Text>
                                                    {user?.email && (
                                                        <Text fontSize="xs" color="gray.500" noOfLines={1}>
                                                            {user.email}
                                                        </Text>
                                                    )}
                                                </Box>
                                                <MenuDivider />
                                                <MenuGroup title="Account">
                                                    <MenuItem onClick={() => navigate("/profile")}>
                                                        Profile
                                                    </MenuItem>
                                                    <MenuItem onClick={() => navigate("/enrolled-courses")}>
                                                        My Courses
                                                    </MenuItem>
                                                </MenuGroup>
                                                <MenuDivider />
                                                <MenuItem
                                                    color="red.500"
                                                    onClick={handleLogout}
                                                    _hover={{ bg: "red.50" }}
                                                >
                                                    Log Out
                                                </MenuItem>
                                            </MenuList>
                                            </Menu>
                                        ) : (
                                            <Button
                                            variant="outline"
                                            onClick={() => navigate("/login")}
                                            colorScheme="teal"
                                            size="sm"
                                            >
                                            Log In
                                            </Button>
                                        )}
                                    </HStack>
                                    )}
                                </HStack>
                            </Container>
                        </Box>
                    </Box>
                    )}
                    {isAuthStandalonePage ? (
                        <Routes>
                            <Route path="/login" element={<LoginPage/>}/>
                            <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
                            <Route path="/reset-password" element={<ResetPasswordPage/>}/>
                        </Routes>
                    ) : (
                    <Box w="100%" maxW="100%" mt={0} px={0}>
                    <Routes>
                        <Route path="/" element={<LandingPage />} />
                        {
                            protected_routes.map(route =>
                                <Route key={route.path} path={route.path} element={route.element}/>
                            )
                        }
                        <Route path="/login" element={<LoginPage/>}/>
                        <Route path="/forgot-password" element={<ForgotPasswordPage/>}/>
                        <Route path="/reset-password" element={<ResetPasswordPage/>}/>
                        <Route path="/confirmation/:registrationId" element={<Acknowledgement/>}/>
                        <Route path="/attendance/:attendanceId" element={<Attendance/>}/>
                        <Route path="/attendance" element={<AttendanceSelection/>}/>
                        <Route path="/enrolled-courses" element={<EnrolledCourses/>}/>
                        <Route path="/profile" element={<ProtectedRoute><Profile/></ProtectedRoute>}/>
                        <Route path="/all-assessments" element={<AssessmentForCourses/>}/>
                        <Route path="/courses/:courseRunId" element={<EachCourse/>}/>
                        <Route path="/assessment/:assessmentID" element={<EachAssessment/>}/>
                        <Route path="/courses-and-programs" element={<CertificateSelection/>}/>
                        <Route path="/registration" element={<Registration/>}/>
                        <Route path={routes.FULL_CERT_REGISTRATION} element={<FullCertRegistration/>}/>
                        <Route path={`${routes.FULL_CERT_REGISTRATION}/:id`} element={<FullCertRegistration/>}/>
                        <Route path="/registration-pending/:registrationID" element={<RegistrationPending/>}/>
                        <Route path="/testpage" element={<TestLMS />} />
                        <Route path="/qr-testing" element={<QRTesting />} />
                        <Route path="/ssg-api" element={<SSGAPI />} />
                        <Route path="/enrollment/:registrationID" element={<Enrollment/>}/>
                        <Route path="/student-package/:registrationID" element={<StudentPackage/>}/>
                        <Route path="/success/:registrationID" element={<SuccessPage/>}/>
                        <Route path="/success/registration/:registrationID" element={<SuccessRegistration/>}/>
                        <Route path="/success/acknowledgement/:assessmentID" element={<SuccessAcknowledgement/>}/>
                        <Route path="/course-interest-received/:registrationID" element={<CourseInterestReceived/>}/>
                        <Route path="/course-registration-form/:registrationID" element={<CourseRegistrationForm/>}/>
                        <Route path="/smecheck/:registrationID" element={<SMECheck/>}/>
                        <Route path="/credit-pay-api" element={<CreditPayAPI />} />
                        <Route path="/forms" element={<Forms />} />
                        <Route path="/verify-email/:token" element={<VerifyEmail />} />
                    </Routes>
                    </Box>
                    )}
                </Box>
            </AuthProvider>
    );
}

function RouterApp() {
    const {isLoading} = useAuth()
    //console.log(isLoading)
    if (isLoading) {
        return (
            <div>
                Loading
            </div>
        )
    } else {
        return (
            <Outlet/>
        )
    }
}

export default App;
